import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Белое озеро';

    const images = [
        {
            original: require('../img/virtualtours/BeloeLike/bel000.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel000.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel001.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel001.jpg'),
            description: 'Лес',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel002.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel002.jpg'),
            description: 'Турбаза Спутник',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel003.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel003.jpg'),
            description: 'Турбаза Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel004.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel004.jpg'),
            description: 'Турбаза',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel005.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel005.jpg'),
            description: 'Жилой корпус',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel006.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel006.jpg'),
            description: 'Туристы',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel007.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel007.jpg'),
            description: 'Лес на берегу',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel008.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel008.jpg'),
            description: 'Белое озеро - берег',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel009.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel009.jpg'),
            description: 'Волны',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel010.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel010.jpg'),
            description: 'Берег',
        },

        {
            original: require('../img/virtualtours/BeloeLike/bel011.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel011.jpg'),
            description: 'Белое озеро, лето',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel012.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel012.jpg'),
            description: 'Отдых у озера',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel013.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel013.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel014.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel014.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel015.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel015.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel016.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel016.jpg'),
            description: 'Отдых',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel017.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel017.jpg'),
            description: 'Утка',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel018.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel018.jpg'),
            description: 'Утка. Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel019.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel019.jpg'),
            description: 'Протока к Рогознянскому озеру',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel020.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel020.jpg'),
            description: 'Протока',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel021.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel021.jpg'),
            description: 'Мост через протоку',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel022.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel022.jpg'),
            description: 'Протока к Рогознянскому озеру',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel023.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel023.jpg'),
            description: 'Рогознянское озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel024.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel024.jpg'),
            description: 'Санаторий',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel025.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel025.jpg'),
            description: 'Рогознянское озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel026.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel026.jpg'),
            description: 'Рогознянское озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel027.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel027.jpg'),
            description: 'Рогознянское озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel028.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel028.jpg'),
            description: 'Кувшинка',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel029.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel029.jpg'),
            description: 'Рогознянское озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel030.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel030.jpg'),
            description: 'Утка',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel031.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel031.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel032.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel032.jpg'),
            description: 'Турбазы зимой',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel033.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel033.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel034.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel034.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel035.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel035.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel036.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel036.jpg'),
            description: 'Следы',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel037.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel037.jpg'),
            description: 'Цветы',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel038.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel038.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel039.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel039.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel040.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel040.jpg'),
            description: 'Белое озеро',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel041.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel041.jpg'),
            description: 'Белое озеро зимой',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel042.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel042.jpg'),
            description: 'Мостик',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel043.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel043.jpg'),
            description: 'Канал',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel044.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel044.jpg'),
            description: 'Канал к Черному озеру',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel045.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel045.jpg'),
            description: 'Черное озеро зимой',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel046.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel046.jpg'),
            description: 'Снег',
        },
        {
            original: require('../img/virtualtours/BeloeLike/bel047.jpg'),
            thumbnail: require('../img/virtualtours/BeloeLike/mbel047.jpg'),
            description: 'Крапива',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>БРЕСТСКАЯ ГРУППА ОЗЁР, включает 7 озёр, образующих узкую полосу, вытянутую с севера на юг
                        параллельно Западному Бугу: Белое озеро, Селяховское озеро, Рогознянское озеро, Меднянское
                        озеро, Тайное озеро, Страдечское озеро, Чёрное озеро. Общая площадь 2,02 км2. Объём воды 6 млн.
                        м3. Озёра проточные.</p>
                    <p>Белое и Рогознянское соединены протокой с Чёрным озером, Селяховское и Тайное имеют сток в
                        Западный Буг, Белое, Чёрное и Рогознянское — в Середовую Речку, Меднянское и Страдечское — в
                        реку Спановка. Водосбор в пределах Брестского Полесья. Распространены болотные массивы низинного
                        типа. Рельеф осложняется дюнами с относительными высотами до 10м. Озеро Тайное принадлежит к
                        типу озёр-разливов с плоской котловиной и небольшими глубинами, остальные —
                        суффозионно-карстовые; для них характерны небольшие площади, узкая литораль и быстрое нарастание
                        глубин (до 21,5-м в озеро Белое). Характерна слабая зарастаемость озёр: отдельные участки
                        тростника, камыша, встречаются кубышка, кувшинка, рдест блестящий и плавающий. Минерализация
                        воды до 200 мг/л. На водосборе осуществляется интенсивная мелиорация болот и заболоченных
                        земель, некоторые озёра соединены каналами с болотами, что обуодовливает небольшую прозрачность
                        воды (до 1,7 м) и высокую цветность. В пределах озёр курорт «Озеро Белое».</p>
                    <p>БЕЛОЕ ОЗЕРО, в 45 км к югу от Бреста, в бассейне Середрвой Речки. Входит в Брестскую группу озёр.
                        Площадь 0,5 км2. Длина 1,03 км, наибольшая ширина 600 м, наибольшая глубина 21,5 м, средняя 5,1
                        м. Объём воды 2,6 млн. м3. На территории водосбора (площадь 140 км2) заболоченные понижения
                        чередуются с дюнными грядами. Береговая линия (длина 2,8 км) слабоизвилистая. Склоны невысокие,
                        песчаные, под лесом. Минерализация воды до 150 мг/л, прозрачность до 1,7 м. Мезотрофное.
                        Проточное: каналами соединено с Рогознянским озером и Чёрным озером. Слабо зарастает,
                        преимущественно в северных и юго-восточных частях (преобладают камыш, тростник), ширина полосы
                        растительности 5—10 м. В сев. части встречается рдест блестящий и плавающий. Обитают лещ,
                        плотва, сом, щука, окунь. Вокруг озера курорт «Озеро Белое».</p>
                    <p>БЕЛОЕ, озеро в Брестском районе, в бассейне Середовой Речки, в 3 км к северо-востоку от деревни
                        Дубица (Домачевское хозяйство). Площадь 0,5 км2. Длина 1,03 км, максимальная ширина 0,6 км,
                        максимальная глубина 21,5 м, средняя 5,1 м, длина береговой линии 2,8 км. Водосбор 140 км2.
                        Котловина овальная. Склоны невысокие, покрыты лесом. Берега песчаные, северный — сплавинный. Дно
                        выстлано песчаными отложениями и сапропелями. Каналами соединено с озёрами Рогознянское и
                        Чёрное. Вокруг озера зона отдыха и курорта Озеро Белое, на берегу турбаза.
                    </p>
                    <p>РОГОЗНЯНСКОЕ ОЗЕРО, Збунинское озеро , в 48 км к югу от Бреста, в бассейне Середовой Речки.
                        Входит в Брестскую группу озёр. Площадь 0,43 км . Длина 1,1 км, наибольшая ширина 500 м,
                        наибольшая глубина 4,8 м, средняя 2 м. Объём воды 0,85 млн. м3.
                        Площадь водосбора 3 км2. Береговая линия (длина 3,3 км) извилистая.
                        Берега высокие, на западе сплавинные. Минерализация воды около 130 мг/л. Эвтрофное. Соединено
                        канавой с Белым озером, на западе вытекает ручей в Середовую Речку. Зарастает вдоль берегов
                        тростником (ширина полосы до 30 м), растут кувшинка, кубышка, рдест блестящий и плавающий.
                        Обитает лещ, плотва, сом, щука, окунь. На берегу озера санаторий «Берестье».</p>
                    <p>РОГОЗНЯНСКОЕ, Збунинское, озеро в Брестском районе, в бассейне Середовой Речки, в 3,5 км к западу
                        от деревни Рогозно (Знаменское хозяйство). Входит в Брестскую группу озёр. Площадь 0,43 км2.
                        Длина 1,1 км, максимальная ширина 0,5 км, максимальная глубина 4,8 м, средняя 2 м. Водосбор 3
                        км2. Котловина состоит из двух плёсов. Склоны высотой 3 - 4 м, поросли лесом, на севере и
                        востоке озеро окаймлено дюнами. Берега высокие, на западе сплавинные. Ложе плоское, шириной
                        мелководной зоны до 100 м. Дно выстлано песчаными отложениями и сапропелем. Зарастает вдоль
                        берегов, ширина полосы надводной растительности до 30 м. Соединено канавой с озером Белое, на
                        западе вытекает ручей в Середовую Речку. Расположено в пределах курортной зоны Белое; на берегу
                        санаторий “Берестье”.</p>
                    <p>ЧЁРНОЕ, озеро в Брестском районе, в бассейне Середовой Речки. В пределах зоны отдыха Белое Озеро.
                        Площадь 0,1 км2. Длина 0,43 км, максимальная ширина 0,33 км, максимальная глубина 7,5 м, средняя
                        3,5 м. Водосбор 0,83 км2. Берега заболочены, поросли лесом. Дно выстлано сапропелем. Соединено
                        каналом с озером Белое.</p>
                    <p>ЧЁРНОЕ ОЗЕРО, в 45 км к югу от Бреста, в бас. Середовой Речки.
                        Входит в Брестскую группу озёр.
                        Площадь ОД км2. Длина 430 м, наибольшая ширина 330 м, наибольшая глубина 7,5 м, средняя 3,5 м.
                        Объём воды 0,35 млн. м3. Водосбор (пл. 0,83 км2) низинный, заболоченный.
                        Длина береговой линии 1,3 км. Берега низкие, под лесом. У южного берега сплавина шириной до 6 м.
                        Озеро, слабо зарастает. Минерализация воды до 160 мг/л, прозрачность 1,2 м. Эвтрофное. Соединено
                        каналом с Белым озером. Обитают карась, плотва, щука.</p>
                </div>
            </div>
        </>
    );
}